/**
 * 提供信息收集相关API
 */
define(['base64', 'apiUtil'], function (Base64, apiUtil) {
  let { executeApi, asyncExecuteApi } = apiUtil;

  const ACTION_PAY = 'pay_page';

  const IC_FAIL_TARGET = {
    PAGE: 1,
    QRCODE: 2,
  };

  var guid = '';
  var uuid = '';
  var hdid = '';
  var dist = '';
  var version = '';
  var appName = 'wpp';
  var resourceVersion = '';

  var appInfo = null;
  asyncExecuteApi('getAppInfo').done((result) => {
    try {
      appInfo = JSON.parse(result);
      guid = appInfo.guid;
      uuid = appInfo.uuid;
      hdid = appInfo.hdid;
      dist = appInfo.dist;
      version = appInfo.version;
      appName = appInfo.name;
    } catch (e) {
    }
  });

  var _moduleName = '';
  var api = {
    IC_FAIL_TARGET,

    getGUID() {
      return guid;
    },

    getUUID() {
      return uuid;
    },

    getHDID() {
      return hdid;
    },

    getDist() {
      return dist;
    },

    getVersion() {
      return version;
    },

    getAppName() {
      return appName;
    },

    sendInfoCollect(action/*, args... */) {
      var url = 'dm=/wps/client/app&action=' + action + '&p0=' + guid + '&p1=' + appName + '&p2=' + version + '&p3=' + dist + '&p4=' + resourceVersion;
      var str = '';
      var argsLen = arguments.length - 1;
      for (var i = 0; i < argsLen; i++) {
        str += '&p' + (5 + i) + '=' + arguments[i + 1];
      }

      str += '&pnum=' + (argsLen + 5);
      console.log(str);

      var tempImg = new Image();
      tempImg.src = 'http://info.wps.cn/wpsv6internet/infos.ads?v=D1S1E1&d=' + Base64.encode(url + str) + '&_t=' + +new Date();
    },


    setModuleName(name) {
      _moduleName = name;
    },

    // 支付界面展示量
    sendPaymentDisplay(paywayIndex) {
      api.sendInfoCollect(ACTION_PAY, _moduleName, 'display', paywayIndex);
    },

    // 支付界面按钮点击量
    sendPaymentClickBtn(targetIndex, btnIndex) {
      api.sendInfoCollect(ACTION_PAY, _moduleName, 'clickBtn', targetIndex, btnIndex);
    },

    // 支付页面分支页面展示量
    sendPaymentBranchDisplay(targetIndex, resultIndex) {
      api.sendInfoCollect(ACTION_PAY, _moduleName, 'branchDisplay', targetIndex, resultIndex);
    },

    // 支付页面分支页面按钮点击量
    sendPaymentBranchClickBtn(targetIndex, paywayIndex, branchBtnIndex) {
      api.sendInfoCollect(ACTION_PAY, _moduleName, 'branchClickBtn', targetIndex, paywayIndex, branchBtnIndex);
    },

    // 支付页加载失败
    sendPaymentLoadFail(target) {
      api.sendInfoCollect(ACTION_PAY, _moduleName, 'loadFail', target);
    }
  };
  return api;
});



/** WEBPACK FOOTER **
 ** ./src/modules/unipay/scripts/apiv2/collectApi.js
 **/